import { apiService } from './api';
import { Employee, CreateEmployeeRequest, RestaurantRoleEntry } from '../types';

export const employeeService = {
  // Employee CRUD
  getEmployeesByOrganization: async (organizationId: string): Promise<Employee[]> => {
    const response = await apiService.get<Employee[]>(`/organizations/${organizationId}/employees`);
    return response.data;
  },

  getEmployee: async (organizationId: string, employeeId: string): Promise<Employee> => {
    const response = await apiService.get<Employee>(`/organizations/${organizationId}/employees/${employeeId}`);
    return response.data;
  },

  createEmployee: async (organizationId: string, data: CreateEmployeeRequest): Promise<Employee> => {
    const response = await apiService.post<Employee>(`/organizations/${organizationId}/employees`, data);
    return response.data;
  },

  updateEmployee: async (organizationId: string, employeeId: string, data: Partial<CreateEmployeeRequest>): Promise<Employee> => {
    const response = await apiService.put<Employee>(`/organizations/${organizationId}/employees/${employeeId}`, data);
    return response.data;
  },

  deleteEmployee: async (organizationId: string, employeeId: string): Promise<void> => {
    await apiService.delete(`/organizations/${organizationId}/employees/${employeeId}`);
  },

  toggleEmployeeStatus: async (organizationId: string, employeeId: string): Promise<Employee> => {
    const response = await apiService.patch<Employee>(`/organizations/${organizationId}/employees/${employeeId}/status`);
    return response.data;
  },

  // Restaurant Role Assignment (embedded in Employee)
  getRestaurantRoles: async (organizationId: string, employeeId: string): Promise<RestaurantRoleEntry[]> => {
    const response = await apiService.get<RestaurantRoleEntry[]>(
      `/organizations/${organizationId}/employees/${employeeId}/restaurant-roles`
    );
    return response.data;
  },

  // Assign or update roles for a specific restaurant (upsert)
  assignRestaurantRole: async (
    organizationId: string,
    employeeId: string,
    restaurantId: string,
    roles: string[]
  ): Promise<Employee> => {
    const response = await apiService.post<Employee>(
      `/organizations/${organizationId}/employees/${employeeId}/restaurant-roles`,
      { restaurantId, roles }
    );
    return response.data;
  },

  removeRestaurantRole: async (
    organizationId: string,
    employeeId: string,
    restaurantId: string
  ): Promise<void> => {
    await apiService.delete(
      `/organizations/${organizationId}/employees/${employeeId}/restaurant-roles/${restaurantId}`
    );
  },
};
